import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPerguntas() {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas/perguntas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposRespostas() {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas/respostas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTodos(filtro) {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas?status=${filtro.status != null ? filtro.status : ''}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFiltros() {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas/filtros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas/${despesaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovar(despesaId, avaliacoesDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/gerentes/despesas/${despesaId}/aprovar`, avaliacoesDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovar(despesaId, justificativaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/gerentes/despesas/${despesaId}/reprovar`, justificativaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas/${despesaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas/${despesaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/gerentes/despesas/${despesaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}